export const handleProductNutritionTabClick = () => {
  const nutritionTabsContainer = document.querySelector(
    '.nutrition-panel-tabs.bundled-products'
  );
  if (!nutritionTabsContainer) {
    return;
  }

  const nutritionTabs = nutritionTabsContainer.querySelectorAll('label');
  nutritionTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      document
        .querySelectorAll('.nutrition-panel-tabs label')
        .forEach((label) => label.classList.remove('active'));
      document
        .querySelectorAll('.nutrition-tabs')
        .forEach((container) => container.classList.remove('active'));

      const tabIndex = tab.getAttribute('for');
      tab.classList.add('active');
      document
        .querySelector(`.nutrition-tabs.${tabIndex}`)
        .classList.add('active');
    });
  });
};
